import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { TtIcon as Icon } from '@23/react'

import { PollCreateEditFormComponent } from '..'
import { Button as ButtonComponent } from '../../../../components'

import './CreatePollComponent.scss'

const CreatePollComponent = (props) => {
  const {
    renderPollUnitWrapper,
    styles,
    iconColor,
    accentColor,
    onCreateEditSubmit,
    toggleFormVisibility,
    isFormVisible,
  } = props

  return (
    <div className="create-poll-component">
      {isFormVisible ? (
        <PollCreateEditFormComponent
          form="poll-create-poll-form"
          styles={styles}
          accentColor={accentColor}
          iconColor={iconColor}
          renderPollUnitWrapper={renderPollUnitWrapper}
          onCancelPollChanges={toggleFormVisibility}
          onSubmit={onCreateEditSubmit}
        />
      ) : (
        <div className="create-poll-button-wrapper">
          <ButtonComponent
            onClick={toggleFormVisibility}
            color="themed"
            className="create-new-poll-button"
            round
          >
            <Icon
              className="create-poll-button-icon"
              name="plus"
              library="23"
            />
            <FormattedMessage defaultMessage="Create New Poll" />
          </ButtonComponent>
        </div>
      )}
    </div>
  )
}

CreatePollComponent.propTypes = {
  accentColor: PropTypes.string.isRequired,
  // TODO (noahlaux): Refactor with TS
  // eslint-disable-next-line react/no-unused-prop-types
  mode: PropTypes.oneOf(['create', 'edit']),
  renderPollUnitWrapper: PropTypes.func,
  onCreateEditSubmit: PropTypes.func,
  toggleFormVisibility: PropTypes.func,
  iconColor: PropTypes.string,
  isFormVisible: PropTypes.bool,
  // TODO (noahlaux): Refactor with TS
  // eslint-disable-next-line react/no-unused-prop-types
  onCancelPollChanges: PropTypes.func,
  styles: PropTypes.shape({
    inputStyle: PropTypes.object,
    buttonStyle: PropTypes.object,
    secondaryButtonStyle: PropTypes.object,
  }),
}

export default CreatePollComponent
